var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom card-stretch gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" " + _vm._s(_vm.currentUser.nome) + " ")])])]), _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Email: " + _vm._s(_vm.currentUser.usuario) + " ")])])]), _c('b-form', {
    staticClass: "form",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nomeGroup",
      "label-for": "nome",
      "label": "Nome de apresentação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nome",
      "autocomplete": "off",
      "autofocus": "",
      "maxlength": "255",
      "type": "text"
    },
    model: {
      value: _vm.nome,
      callback: function callback($$v) {
        _vm.nome = $$v;
      },
      expression: "nome"
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "password",
      "label-for": "password",
      "label": "Nova senha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "new-password",
      "type": "password"
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "confirmPassword",
      "label-for": "confirmPassword",
      "label": "Confirme a senha"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "new-password",
      "type": "password"
    },
    model: {
      value: _vm.confirmPassword,
      callback: function callback($$v) {
        _vm.confirmPassword = $$v;
      },
      expression: "confirmPassword"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_senha",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvarNovaSenha
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };